/**
 * Generated runtime TestId mirror for frontend/src/components/restriction-rules/VersionHistoryCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const VersionHistoryCardTestIds = {
  cardTitleVersionHistory: "card-title-version-history",
  versionEmpty: "version-empty",
  versionError: "version-error",
  versionHistoryCard: "version-history-card",
  versionLoading: "version-loading",
  versionAuthor: (version_id: string) => `version-author-${version_id}`,
  versionAuthorPrefix: () => "version-author-" as TestIdPrefix,
  versionCurrent: (version_id: string) => `version-current-${version_id}`,
  versionCurrentPrefix: () => "version-current-" as TestIdPrefix,
  versionNumber: (version_id: string) => `version-number-${version_id}`,
  versionNumberPrefix: () => "version-number-" as TestIdPrefix,
  versionRow: (version_id: string) => `version-row-${version_id}`,
  versionRowPrefix: () => "version-row-" as TestIdPrefix
} as const;
